import {until} from 'lit-html/directives/until';
import '@modules/show-modal';
import {
  permissions,
  sdoNs,
  pages,
} from '@modules/constants-enumerate';
import '@modules/auth-context';
import '@modules/link-to';
import '@modules/hide-for-level';
import '../modals';
import '../license-info-row';
import licenseInfoStyles from './license-info-row.css';
import {
  accessibleProductLabels,
  activationStartTypeLabels,
  generalLabels,
  licenseHomeAccessTypeLabels
} from '@modules/i18n-labels';
import '@modules/wrap-unsafe-html';
import {wrapUnsafeHtml} from '@modules/wrap-unsafe-html';

const licenseTransferPermissions = [permissions.LICENSE_TRANSFER];

export default (ctx, html) => html`
${ctx.childGroupsLicenseCount.total > 0 || ctx.childGroupsLicenseCount.assigned > 0
|| ctx.childGroupsLicenseCount.available > 0 || ctx.childGroupsLicenseCount.redeemed > 0 ? html`
<div class="card shadow-sm py-4 rounded border-0 mb-5">
  <div class="border-bottom px-4 pb-3">
    <license-info-row class="border-dashed-bottom pb-3 mb-3" .row="${{
  groupName: ctx.groupName,
  total: ctx.currentGroupLicenseCount.total,
  assigned: ctx.currentGroupLicenseCount.assigned,
  unassigned: ctx.currentGroupLicenseCount.available,
  redeemed: ctx.currentGroupLicenseCount.redeemed,
}}"></license-info-row>
    <license-info-row
      .styles="${[licenseInfoStyles]}"
      @click="${() => ctx.scrollIntoView('inventory-allocation')}"
      .row="${{
  label: until(ctx.__('<tt-Gdjl/buB>', 'Given to Lower Levels:')),
  total: ctx.childGroupsLicenseCount.total,
  assigned: ctx.childGroupsLicenseCount.assigned,
  unassigned: ctx.childGroupsLicenseCount.available,
  redeemed: ctx.childGroupsLicenseCount.redeemed,
}}"></license-info-row>
  </div>
  <div class="px-4 py-3">
    <license-info-row class="font-weight-bold" .row="${{
  label: until(ctx.__('<tt-QI4ITx7K>', 'All Licenses:')),
  total: ctx.currentGroupLicenseCount.total + ctx.childGroupsLicenseCount.total,
  assigned: ctx.currentGroupLicenseCount.assigned + ctx.childGroupsLicenseCount.assigned,
  unassigned: ctx.currentGroupLicenseCount.available + ctx.childGroupsLicenseCount.available,
  redeemed: ctx.currentGroupLicenseCount.redeemed + ctx.childGroupsLicenseCount.redeemed
}}"></license-info-row>
  </div>
</div>` : ''}
<div class="card shadow-sm pt-5 pb-3 px-4 rounded border-0">
  <h4 class="mb-0 pb-2 border-dashed-bottom">${until(ctx.__('<tt-9S8uePTZ>', 'Product Information'))}</h4>
  <div class="row pt-3">
    <div class="col">
      <div class="text-muted">${until(ctx.__('<tt-625qxWlW>', 'Product Name'))}</div>
      <div class="font-size-bigger">${accessibleProductLabels[ctx.product]}</div>
    </div>

    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until(ctx.__('<tt-zpF0vzdI>', 'Home Access Type'))}</div>
        <div class="font-size-bigger">${until(licenseHomeAccessTypeLabels[ctx.info?.access_type])}</div>
      </div>
    </div>

    <div class="col">
      ${ctx.info.fspk ? html`
      <div class="d-flex flex-column">
        <div class="text-muted">${until(ctx.__('<tt-f+q79jc/>', 'FSPK'))}</div>
        <div class="font-size-bigger">${until(generalLabels.Yes)}</div>
      </div>` : ''}
    </div>
  </div>

  <div class="spacer-sm"></div>

  <h4 class="mb-0 pb-2 border-dashed-bottom">${until(ctx.__('<tt-Vnw6RHGR>', 'License Details'))}</h4>
  <div class="row pt-3">
    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until(ctx.__('<tt-Bsq0EC21>', 'License Name'))}</div>
        <div class="font-size-bigger">${ctx.info.name}</div>
      </div>
    </div>

    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until((ctx.info.type === 'site') ? generalLabels.DurationLabel : generalLabels.FixedEndDateLabel)}</div>
        <div class="font-size-bigger ${(ctx.info.expired) ? 'text-danger' : ''}">
            ${until((ctx.info.type === 'site') ?
              ctx.info.fixed_duration_label :
              (ctx.info.expired) ? until(ctx._r(ctx.__('<tt-g8QAtL1p>', '%r1% (Expired)'), ctx.info.fixed_end_date)) : ctx.info.fixed_end_date)}
        </div>
      </div>
    </div>

    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until(ctx.__('<tt-R3jqYfGW>', 'ID'))}</div>
        <div class="font-size-bigger">${ctx.info.id}</div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until(generalLabels.TransferableLicense)}</div>
        <div class="font-size-bigger">${ctx.info.transferable ? until(generalLabels.Yes) : until(generalLabels.No)}</div>
      </div>
    </div>

    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until(ctx.__('<tt-yZISvA/V>', 'Usage Trigger'))}</div>
        <div class="font-size-bigger">${until(activationStartTypeLabels[ctx.info.activation_start_type])}</div>
      </div>
    </div>

    <div class="col">
      <div class="d-flex flex-column">
        <div class="text-muted">${until(ctx.__('<tt-nAQlUrMP>', 'Automatically License New Students'))}</div>
        <div class="font-size-bigger">${ctx.info.auto_license ? until(generalLabels.Yes) : until(generalLabels.No)}</div>
      </div>
    </div>
  </div>
${!ctx.info.expired ? html`
  <div class="text-center mt-5">
    <hide-for-level .disableLevels="${[ctx.tierLevels]}" disable-classes>
      <auth-context show-on-auth .permissions="${licenseTransferPermissions}">
        <show-modal tabIndex="0" class="btn btn-primary rounded-pill px-5" modal-id="${sdoNs.LICENSE_DISTRIBUTE}">
          ${until(ctx.__('<tt-SUvb2PeI>', 'Give to Lower Levels'))}
        </show-modal>
      </auth-context>
    </hide-for-level>
    <div class="pt-3">${until(ctx.__('<tt-ELEkLwig>', 'Available:'))} <span class="${ctx.currentGroupLicenseCount.available === 0 ? 'text-danger' : ''}"> ${ctx.currentGroupLicenseCount.available}</span></div>
    <hr />
    <link-to href="${pages.STUDENT_SEARCH}" class="text-primary">${until(ctx.__('<tt-rmf5qgFr>', 'To assign available licenses to students, you may do so individually or in bulk from the students page, or any of the other manage sections.'))}</link-to>
  </div>
`: ''}
</div>
`;
